module.exports = __webpack_public_path__ + "static/media/jne_logo.ea8207fe.svg";